export enum FeatureEnum {
    SHIELD_CONFIGURATION = 'shield_configuration',
    POSTBACK_LINK = 'postbacklink',
    CHECKOUT_CONFIGURATION = 'checkout_configuration',
    VISITA = 'visita',
    QUANTIDADE_PERFIS = 'quantidade_perfis',
    POSTBACK_LINK_ENVIO = 'postback_link_envio',
    CHECKOUT = 'checkout',
    SHIELD_POSTBACK_AUTO = 'shield_postback_auto',
    SHIELD_CHECKOUT_AUTO = 'shield_checkout_auto',
    INTEGRACAO_URL_PRODUTOR = 'integracao_url_produtor',
    SHIELD_IP_BLOCK_CAMPAIGN = 'shield_ip_block_campaign',
    TOTAL_GOOGLE_ADS_ACCOUNT = 'total_google_ads_account',
    TOTAL_META_ADS_ACCOUNT = 'total_meta_ads_account',
    TOTAL_NEWSBREAK_ADS_ACCOUNT = 'total_newsbreak_ads_account',
    TOTAL_TABOOLA_ADS_ACCOUNT = 'total_taboola_ads_account',
    TOTAL_TAG_RATOEIRA = 'total_tag_ratoeira',
    TOTAL_REDE_ADS = 'total_rede_ads',
    HABILITAR_IP_BLOCK = 'habilitar_ip_block',
}
